import { Box, Typography, Chip } from '@mui/material';
import {
  Timeline, TimelineItem, TimelineSeparator, TimelineConnector,
  TimelineDot, TimelineContent, timelineItemClasses,
} from '@mui/lab';
import { useCaseFieldData } from '../../../hooks/useCaseField';
import type { FieldMode } from '../../../hooks/useCaseField';

function formatDate(iso: string | null | undefined): string {
  if (!iso) return '\u2014';
  return new Date(iso).toLocaleString();
}

const AuditTimeline: React.FC<{ mode: FieldMode }> = ({ mode }) => {
  const data = useCaseFieldData(mode);
  const trail = data.auditTrail ?? [];

  if (trail.length === 0) return null;

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>Audit Trail</Typography>
      <Timeline sx={{
        p: 0, m: 0,
        [`& .${timelineItemClasses.root}:before`]: { flex: 0, padding: 0 },
      }}>
        {trail.map((entry, i) => (
          <TimelineItem key={i}>
            <TimelineSeparator>
              <TimelineDot color="primary" variant="outlined" sx={{ my: 0.5 }} />
              {i < trail.length - 1 && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineContent sx={{ py: 0.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Chip label={entry.toStatus} size="small" variant="outlined" />
                <Typography variant="caption" color="text.secondary">
                  {formatDate(entry.occurredAt)}
                </Typography>
              </Box>
              <Typography variant="caption" color="text.secondary">
                {entry.reason} {entry.userId && `\u2014 ${entry.userId}`}
              </Typography>
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </Box>
  );
};

export default AuditTimeline;
